import { Badge, Box, Heading, HStack } from '@chakra-ui/react';
import { ActivityCompanyReportingRequirementViewModel } from '../../../../../features/activities/editActivity/editReportingRequirements/types';

type Props = {
  viewModel: ActivityCompanyReportingRequirementViewModel;
};

export const ReportingRequirementViewModelDisplay = ({ viewModel }: Props) => {
  return (
    <Box>
      <HStack>
        <Heading size='xs' padding={'2px'} margin={0}>
          {viewModel.Name} test
        </Heading>
        {viewModel.IsMandatory && (
          <Badge backgroundColor='red' color='white'>
            Mandatory
          </Badge>
        )}
        {viewModel.IsRequired && (
          <Badge backgroundColor='orange' color={'white'}>
            Required
          </Badge>
        )}
      </HStack>

      {viewModel.Example && (
        <Box fontSize={'small'} fontStyle={'italic'}>
          Example: {viewModel.Example}
        </Box>
      )}
    </Box>
  );
};
